import { indexEntries } from '@/mocks/home';

export default function DifferenceIndex() {
  return (
    <section id="index" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 mb-4">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-list-check-2" />
              </span>
              差异索引
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              换一家之前，先把这些差别过一遍
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
            索引比结论更有用。下面这六条，是黑料网站同类之间最常被忽略、却最影响日常使用体验的差别。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {indexEntries.map((item) => (
            <a
              key={item.id}
              href="#guide"
              className="group flex flex-col rounded-lg border border-background-200/70 bg-background-100/60 p-6 md:p-7 transition-colors hover:border-primary-300 hover:bg-background-100 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="font-heading text-2xl text-primary-500/70">{item.no}</span>
                <span className="px-2.5 py-1 rounded-full text-xs bg-secondary-100 text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                顺着看下去
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}